import { HashLink as Link } from 'react-router-hash-link';

export default function Navbar() {
  return (
    <nav className="bg-gradient-to-r from-[#FFD700] to-[#FAF3C0] text-black px-6 py-3 shadow-lg w-full fixed top-0 left-0 z-50 border-b border-black/20">
      <div className="max-w-7xl mx-auto flex justify-between items-center flex-wrap">

        {/* Logo Section */}
        <div className="flex items-center space-x-3">
          <img
            src="/log.png"
            alt="Ferej Hotel Logo"
            className="w-12 h-12 sm:w-14 sm:h-14 object-contain select-none drop-shadow-[0_2px_6px_rgba(0,0,0,0.3)]"
          />
          <span className="hidden sm:block text-lg sm:text-2xl font-[Playfair_Display] tracking-wide text-black font-semibold">
            Ferej Hotel
          </span>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-wrap justify-start sm:justify-start ml-[-40px] sm:ml-[-80px] space-x-3 sm:space-x-8 text-sm sm:text-lg font-[Poppins] mt-2 sm:mt-0">
          {[
            { to: '/#about', label: 'About Us' },
            { to: '/#rooms', label: 'Available Rooms' },
            { to: '/#contact', label: 'Contact' },
          ].map((link, i) => (
            <Link
              key={i}
              smooth
              to={link.to}
              className="relative px-4 py-1 border border-black/30 rounded-full text-black font-medium 
                        transition-all duration-300 ease-in-out 
                        hover:bg-black hover:text-white hover:border-[#FFD700]
                        hover:shadow-[0_0_10px_rgba(0,0,0,0.3)] active:scale-95"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}
